<template>
  <tr :class="rowClass">
    <td>
      {{ text }}
    </td>
    <td>
      <b-upload @input="uploadFile()" v-model="file" :accept="accept">
        <b-button
          class="bulma-upload-button"
          :icon-left="icon"
          :loading="loading"
        />
      </b-upload>
    </td>
    <td>
      <b-tag
        v-if="value"
        closable
        aria-close-label="Close tag"
        @close="$emit('input', null)"
        ><a :href="value.url || value.s3ObjectLocation" target="_blank">{{
          value.name
        }}</a>
        {{ fromUnix(value.createdAt) }}</b-tag
      >
    </td>
    <slot></slot>
  </tr>
</template>

<script>
import S3 from 'aws-s3'
import moment from 'moment'

export default {
  props: {
    bucketName: {
      type: String,
      default: 'ecobanka-dev'
    },
    region: {
      type: String,
      default: 'eu-west-1'
    },
    rowClass: {
      type: String,
      default: 'default'
    },
    accessKeyId: {
      type: String,
      default: 'AKIA5UDDMSSXW35UBDWB'
    },
    value: {
      type: Object,
      default: null
    },
    secretAccessKey: {
      type: String,
      default: 'AqAdv7jtiKqrYKtOXXuKEQL0etgRJEvx5xJNM7Bm'
    },
    accept: {
      type: String,
      default:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,zip, image/jpeg,application/x-zip,video/*,.xlsx,application/octet-stream,video/mp4,application/x-zip-compressed,application/vnd.ms-excel,.xls,application/zip,image/png,application/pdf,video/x-m4v'
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      file: null,
      loading: false
    }
  },
  computed: {
    config() {
      return {
        bucketName: this.bucketName,
        dirName: this.dirName,
        region: this.region,
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey
      }
    },
    dirName() {
      return Math.random()
        .toString()
        .slice(2)
    },
    S3Client() {
      return new S3(this.config)
    },
    newFileName() {
      return this.file.name.replace(/ /g, '').replace(/\.[^/.]+$/, '')
    }
  },
  methods: {
    fromUnix(val) {
      if (!val) {
        return ''
      }
      return moment
        .unix(val.substr(0, val.length - 3))
        .tz('Europe/Madrid')
        .format('DD-MM-YYYY, h:mm:ss a')
    },
    uploadFile() {
      let self = this
      self.loading = true
      self.S3Client.uploadFile(self.file, self.newFileName)
        .then(function(data) {
          const locationParts = data.location.split('/')
          const newFile = {
            url: data.location,
            name: locationParts[locationParts.length - 1],
            createdAt: moment()
              .valueOf()
              .toString()
          }
          self.$emit('input', newFile)
          self.file = null
        })
        .catch(err => console.error(err))
        .then(() => (self.loading = false))
    }
  }
}
</script>

<style scoped>
.file-name {
  height: 50px;
}

.bulma-upload-button {
  font-size: 17px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 30px !important;
  min-height: 30px !important;
  background: none !important;
  color: #d23185 !important;
}

.bulma-upload-button:hover {
  background: #d23185 !important;
  color: white !important;
}

.file-name {
  border: none;
}

tr.success {
  background-color: #5cac394a;
}

tr.danger {
  background-color: #f940404a;
}

tr.warning {
  background-color: #f9e2404a;
}

tr.info {
  background-color: #409bf94a;
}
</style>
